<template>
  <div class="popup-wrap">
    <div class="border-radius-8 popup-content">
      <div class="wrap result-wrap">
        <div class="content">
          <template v-if="type === 'loading'">
            <div class="icon loading"></div>
            <div class="text">{{ $t('loginning') }}</div>
          </template>
          <template v-else-if="type === 'success'">
            <div class="icon success"></div>
            <div class="text">{{ $t('login_success_2') }}</div>
          </template>
          <template v-else-if="type === 'fail'">
            <div class="icon fail"></div>
            <div class="text">
              {{ $t('login_fail_2') }}
              <p class="code-tips" v-if="code > 0">{{ code }} - {{ $t(`KGSDK_${code}`) }}</p>
            </div>
          </template>
        </div>
        <div v-if="type === 'fail'" class="btns">
          <Button type="warning" @click="reLogin">{{ $t('try_again') }} </Button>
        </div>
        <!-- <div v-if="type === 'success' && urlParams.source_id === $ENUM.SOURCE_ID_MAP.MICRO_TERMINAL" class="btns">
          <Button type="warning" @click="backToGame">{{ $t('continue') }} </Button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import { sendLogin } from '../utils/Qtbridge'
import { socialLogin } from '@/server/api'
import { mapMutations } from 'vuex'
export default {
  name: 'Result',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    const loginData = this.data.loginData || {}
    return {
      type: 'loading',
      urlParams: JSON.parse(window.localStorage.getItem('sdkParams') || '{}'),
      once_key: undefined,
      loginData,
      code: undefined
    }
  },
  created () {
    this.login()
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'setUserInfo',
      setBindInfo: 'setBindInfo',
      setLoginType: 'setLoginType'
    }),
    login () {
      const data = this.data.loginData || {}
      // if (typeof window.qt !== 'undefined') {
      //   console.log('==> 微端 webview 登录')
      //   // 微端 webview 登录
      //   this.loginWithMicroTerminal(data)
      // } else if (this.urlParams.refer) {
      //   console.log('==> 网站登录，有 refer 需要回跳')
      //   // 网站登录，有 refer 需要回跳
      //   this.loginWithWebsite(data)
      // } else if (this.urlParams.source_id === this.$ENUM.SOURCE_ID_MAP.MICRO_TERMINAL) {
      //   console.log('==> 新版微端登录')
      //   // 新版微端登录
      //   this.loginWithWs(data)
      // }
      this.loginWithWebsite(data)
    },
    // 网页登录
    loginWithWebsite (data, isRegister) {
      // 只有当游戏是 SS(30001)且是官网登录时走游戏passport
      const transBindType = this.$ENUM.SOCIAL_CODE_MAP[data.type]
      const params = {
        gameId: this.urlParams.gid,
        deviceId: localStorage.getItem('social-did'),
        bindType: transBindType,
        accessToken: data.token,
        deviceUuid: localStorage.getItem('social-duuid'),
        register: isRegister || 0,
        bindInfo: {
          id: data.id,
          name: data.name,
          email: data.email || ''
        }
      }
      socialLogin(params).then(res => {
        this.type = 'success'
        // 设置用户绑定信息
        this.setBindInfo(res.bindInfos)
        // 设置用户信息
        const bindInfo = res.bindInfos.filter(x => x.bindType === `${transBindType}`)
        this.setLoginType('account')
        if (bindInfo.length > 0) {
          this.setUserInfo({
            name: bindInfo[0].bindInfo.name || bindInfo[0].bindInfo.email || '',
            ...res,
            loginType: 'social_login'
          })
        }
        this.$emit('loginComplete', res)
        // 存储social_login参数
        localStorage.setItem('social_login_type', transBindType)
        localStorage.setItem('social_login_params', JSON.stringify(params))
      }).catch(err => {
        this.loginHandler(err)
        // this.$msg.success(this.$t(`KGSDK_${err.code}`))
        this.type = 'fail'
        this.code = err.code

        this.$gtag.event('PC_login', {
          login_game_id: this.urlParams.gid,
          login_type: 'web_login',
          login_code: err.code
        })
        console.error(JSON.stringify({
          type: 'axios',
          request: params,
          response: err
        }))
        setTimeout(() => {
          // window.location.href = `${refer}`
          this.$emit('localLogin')
        }, 2000)
      })
    },
    // 微端登录
    loginWithMicroTerminal (data) {
      // const params = {
      //   ...data,
      //   id: data.id.toString()
      // }
      // sendLogin(params)
      //   .then(() => this.type = 'success')
      //   .catch(err => {
      //     this.type = 'fail'
      //     this.code = err.code
      //     this.$msg.success(this.$t(`KGSDK_${err.code}`))
      //   })
    },
    // websocket 登录
    loginWithWs (data, register = 0) {
      // const userInfo = {
      //   ...data,
      //   id: data.id.toString()
      // }
      // this.once_key = this.$utils.getTS()
      // this.$Spin.show()
      // const params = {
      //   action: 'web_login',
      //   userInfo,
      //   once_key: this.once_key,
      //   fp_device_id: window.localStorage.getItem('social-did'),
      //   register
      // }

      // // 用户点击注册上报打点
      // if (register) {
      //   this.$utils.customLog('20016_register', params, {})
      // }

      // this.$socket.push({
      //   params,
      //   cb: resp => {
      //     // 用户点击注册成功后打点
      //     if (params.register && resp.code === 0) {
      //       this.$utils.customLog('20016_register_suc', params, resp)
      //     }
      //     this.loginHandler(resp)
      //   }
      // })
    },
    loginHandler (resp) {
      console.log('==z==> social login resp - ', resp)
      if (resp.action !== 'web_login' && resp.once_key !== this.once_key) return
      this.$Spin.hide()
      if (resp.code === 0) {
        this.type = 'success'
      } else {
        this.type = 'fail'
        this.code = resp.code
        if (resp.code === 20016) {
          this.$dialog(
            {
              title: this.$t('web_tips_title'),
              text: this.$t('register_account_tips'),
              confirmTxt: this.$t('test_confirm'),
              cancelTxt: this.$t('test_cancel')
            },
            () => {
              this.loginWithWebsite(this.data.loginData, 1)
            }
          )
        } else {
          this.$msg.success(this.$t(`KGSDK_${resp.code}`))
        }
        this.$gtag.event('PC_login', {
          login_game_id: this.urlParams.gid,
          login_type: 'ws_login',
          login_code: resp.code
        })
      }
    },
    reLogin () {
      // this.$router.replace({ name: 'Login' })
      this.$emit('changePopup', { name: 'login' })
    }
    // backToGame () {
    //   this.$socket.push({
    //     params: {
    //       action: 'client_top',
    //       once_key: this.once_key
    //     }
    //   })
    // }
  }
  // beforeRouteEnter (to, from, next) {
  //   if (!from.name) {
  //     return next({
  //       path: '/login',
  //       replace: true
  //     })
  //   }
  //   next()
  // }
}
</script>

<style lang='less' scoped >
.r-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  .icon {
    width: 51px;
    height: 51px;
    background: url(~@img/icon_success.png) center center no-repeat;
    background-size: 100% 100%;
  }
  .text {
    color: #111111;
    font-size: 18px;
    line-height: 18px;
    margin-top: 19px;
  }
}
.wrap {
  height: 100%;
  padding: 0 32px 20px;
  display: flex;
  flex-direction: column;
  .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .icon {
    width: 51px;
    height: 51px;
    background: url(~@img/icon_fail.png) center center no-repeat;
    background-size: 100% 100%;
    &.success { background-image: url(~@img/icon_success.png); }
    &.fail { background-image: url(~@img/icon_fail.png); }
    &.loading {
      background-image: url(~@img/icon_loading.png);
      filter: contrast(0.5);
      animation: infiniteRotate linear 2s infinite;
    }
  }
  .text {
    color: #111111;
    font-size: 18px;
    line-height: 18px;
    margin-top: 19px;
    text-align: center;
  }
  .code-tips {
    margin-top: 10px;
    font-size: 12px;
    line-height: 1.5;
    color: #777;
  }
}
@keyframes infiniteRotate {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
